<script setup lang="ts">
import { useDeviceState } from "@/stores/DeviceState";
import DRDropdownItem from "@/components/UI/DRDropdownItem.vue";
import DREditTextDialog from "@/components/UI/feedbacks/DREditTextDialog.vue";
import { ref, toRef } from "vue";
import { useUpdateDrawing } from "@/stores/queries";

const props = defineProps<{
  drawingId?: number;
  drawingName?: string;
}>();
const id = toRef(props, "drawingId");

const deviceState = useDeviceState();
const { mutateAsync: updateDrawing } = useUpdateDrawing(id);

async function renameDrawing(name: string) {
  await updateDrawing({
    fileName: name,
  });
}

const editing = ref(false);

const rules = [
  {
    validator: (value: string) => !!value.trim()?.length,
    message: "Le nom ne peut pas être vide",
  },
];
</script>

<template>
  <DRDropdownItem
    :disabled="!drawingId || !deviceState.isOnline"
    @select="editing = true"
    icon="bi-pencil"
    :label="$t('rename')"
  />
  <DREditTextDialog
    v-model="editing"
    title="Renommer le plan"
    :value="drawingName"
    placeholder="$t('dashboard:enter.new.name')"
    :rules="rules"
    @confirm="renameDrawing($event)"
  />
</template>
